import BaseApiService from "./BaseApiService"
import axios          from "axios"

export default class UserConfigService extends BaseApiService {
  getConfig(key: string) {
    const url = this.getApiUrl("/config/get-config?key=" + key, "config")
    return this.processRequest(axios.get(url))
  }

  setDefaultExtendedFilter(key: string, exfId: number | null) {
    const url = this.getApiUrl("/config/set-default-extended-filter", "config")
    const body = { key, exfId }
    return this.processRequest(axios.post(url, body))
  }
}
